import React, { FC } from 'react'
import { styled } from '../../../lib/stitches'
import * as Slider from './Slider'
import Text from './Text'

const StyledTrackTimingContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '4px'
})

const Container = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '8px'
})

const TrackTimingContainer = StyledTrackTimingContainer

interface TimelineControlsProps {
  value: number
  max: number
  leftLabel: string
  rightLabel: string
  onValueChange?: (value: number[]) => void
  onSlideEnd?: (event: React.PointerEvent) => void
  onSlideStart?: (event: React.PointerEvent) => void
  style?: {}
}

const TimelineControls: FC<TimelineControlsProps> = (props) => {
  const { onValueChange, value, max, leftLabel, rightLabel, onSlideEnd, onSlideStart } = props
  return (
    <Container style={props.style}>
      {leftLabel && (
        <Text small css={{ textAlign: 'right', width: '28px', marginRight: '8px' }}>
          {leftLabel}
        </Text>
      )}
      <Slider.Root
        css={{ flex: 1 }}
        value={[value]}
        max={max}
        minStepsBetweenThumbs={0}
        orientation="horizontal"
        onValueChange={onValueChange}
        onPointerUp={onSlideEnd}
        onPointerDown={onSlideStart}
      >
        <Slider.Track>
          <Slider.Range />
        </Slider.Track>
        <Slider.Thumb />
      </Slider.Root>
      {rightLabel && (
        <Text small css={{ textAlign: 'left', width: '28px', marginLeft: '8px' }}>
          {rightLabel}
        </Text>
      )}
    </Container>
  )
}

export default TimelineControls
